import React from 'react';
import Indkomsttype from '../indkomsttype/indkomsttype';

const AppCompoentRoot = () => {
	return (
		<div>
			<Indkomsttype />
		</div>
	);
};

export default AppCompoentRoot;
